export default "__VITE_ASSET__B1ezS4Vn__"